import httpService from "./httpService";

export default {

  generateOTP() {
    return httpService.post("/otp/generateOTP");
  },

  validateOTP(form) {
    return httpService.post("/otp/validateOTP", form);
  },
}



// WEBPACK FOOTER //
// ./src/services/otpService.js